import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLoadScript } from '@react-google-maps/api';
import { useTranslation } from 'react-i18next';
import { MapLibraries } from '../../types/GoogleMapsApi';
import DealersBand from '../DealersBand';
import useDealershipList from '../../hooks/useDealershipList';
import useLocationLocalStorage from '../../hooks/useLocationLocalStorage';
import { openModal, closeModal, selectIsModalOpened } from '../../reducers/modalHandlerReducer';
import { selectDealersList, clearInfoDetail } from '../../reducers/dealersListReducer';
import DealersModal from '../DealersModal';
import { WrapperContainer } from './ContentWrapper.styles';
import {
  PARTNER_KVPS_SYNC_ID,
  LOCATION_SEARCH_MODAL_OPEN_EVENT,
  PARTNER_ID,
  GEO_ZIP,
} from '../../constants/locationConstants';
import { selectDealerContext } from '../../reducers/dealerContextReducer';

// export type ContentWrapperProps = {
//   isHidden?: boolean;
// };
// const ContentWrapper = ({ isHidden }: ContentWrapperProps) => {
const ContentWrapper = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isModalOpened } = useSelector(selectIsModalOpened);
  const { dealerContextId } = useSelector(selectDealerContext);

  const [isGoogleMapScriptLoaded, setIsGoogleMapScriptLoaded] = useState<boolean>(false);

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.GOOGLE_MAPS_API_KEY ?? '',
    libraries: MapLibraries,
  });

  // A useCallback hook is used to memoize the function and prevent unnecessary re-renders.
  const handleMapLoad = useCallback(() => {
    if (isLoaded) {
      setIsGoogleMapScriptLoaded(true);
    }
  }, [isLoaded]);

  useEffect(() => {
    // Once the map is loaded, setIsGoogleMapScriptLoaded will be called.
    handleMapLoad();
  }, [handleMapLoad]);

  const handleOpenModal = useCallback(() => {
    dispatch(openModal());
  }, [dispatch]);

  const handleCloseModal = useCallback(() => {
    dispatch(clearInfoDetail());
    dispatch(closeModal());
  }, [dispatch]);

  useEffect(() => {
    document.addEventListener(LOCATION_SEARCH_MODAL_OPEN_EVENT, handleOpenModal);

    return () => {
      document.removeEventListener(LOCATION_SEARCH_MODAL_OPEN_EVENT, handleCloseModal);
    };
  }, [handleCloseModal, handleOpenModal]);

  // Check if CTA from another FA has been clicked
  useEffect(() => {
    const handleButtonClick = (event: any) => {
      if (event.target.id === 'select-location') {
        console.log('Location trigger button clicked!');
      }
    };
    document.addEventListener('click', handleButtonClick);
    return () => {
      document.removeEventListener('click', handleButtonClick);
    };
  }, []);

  // ASK
  useDealershipList();
  const { saveDealersToLS, initialData } = useLocationLocalStorage();

  useEffect(() => {
    const isInvalidData = initialData.invalidDataFromLs;
    if (GEO_ZIP && isInvalidData) return undefined;
    if (PARTNER_ID) return undefined;
    // if (dealerContextId) return undefined;
    if (initialData.selectedUserLocation !== undefined) return undefined;

    const timer = setTimeout(handleOpenModal, 1600);

    return () => {
      clearTimeout(timer);
    };
  }, [dealerContextId, handleOpenModal, initialData]);

  return (
    <div>
      {!PARTNER_KVPS_SYNC_ID && isGoogleMapScriptLoaded && (
        <WrapperContainer>
          <DealersBand onModalOpen={handleOpenModal} />
          {/* <div>{isModalOpened && <DealersModal />}</div> */}
          {isModalOpened && (
            <DealersModal onCloseModal={handleCloseModal} saveDealersToLs={saveDealersToLS} />
          )}
        </WrapperContainer>
      )}
    </div>
  );
};

export default ContentWrapper;
